module.exports = __webpack_public_path__ + "img/service-qrcode.26c313e0.jpg";